import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNumber4Square: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconNumber4Square"><Path d="M12.46 8.97949V13.3916H9.70605V13.3037C10.5264 11.8682 11.5049 10.3037 12.3721 8.97949H12.46Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11.7451 7.77246C10.5967 9.51855 9.39551 11.4639 8.2998 13.3682V14.6045H12.4365V16.2275H13.8838V14.6045H15.0205V13.3564H13.8838V7.77246H11.7451Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNumber4Square;
